/* eslint-disable */

import { createContext, useContext, useState, useEffect } from "react";

// Create AuthContext
export const AuthContext = createContext();

// Custom hook for using AuthContext
export const useAuthContext = () => {
  return useContext(AuthContext);
};

// AuthContextProvider to manage auth state globally
export const AuthContextProvider = ({ children }) => {
  const [authUser, setAuthUser] = useState(() => {
    // Retrieve user from local storage
    const storedUser = localStorage.getItem("e-bike");
    return storedUser ? JSON.parse(storedUser) : null;
  });

  // Sync authUser with localStorage on any change
  useEffect(() => {
    if (authUser) {
      localStorage.setItem("e-bike", JSON.stringify(authUser));
    } else {
      localStorage.removeItem("e-bike");
    }
  }, [authUser]);

  return <AuthContext.Provider value={{ authUser, setAuthUser }}>{children}</AuthContext.Provider>;
};
